import { render, staticRenderFns } from "./DrawerReservedStockBatchDetail.vue?vue&type=template&id=ff00dd50&scoped=true&"
import script from "./DrawerReservedStockBatchDetail.vue?vue&type=script&setup=true&lang=js&"
export * from "./DrawerReservedStockBatchDetail.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DrawerReservedStockBatchDetail.vue?vue&type=style&index=0&id=ff00dd50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff00dd50",
  null
  
)

export default component.exports